import CalendarSync from '../integration';

const Integration = () => <CalendarSync />;

export default Integration;
